import React, { useState } from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { useDispatch } from 'react-redux';
import { paymentActions } from '../store/payment.slice';
import { toast } from 'react-toastify';
import HttpStatus from '../helpers/status.enum';
import SpinnerLoader from './SpinnerLoader';

const PayPalCheckoutForm = ({
  paypalOrderId,
  paymentSlug,
  bookingSlug,
  onSuccess,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const [processing, setProcessing] = useState(false);

  if (!paypalOrderId) return null;

  const handleApprove = async () => {
    setProcessing(true);
    try {
      const result = await dispatch(
        paymentActions.updatePaymentStatus({
          booking_slug: bookingSlug,
          payment_slug: paymentSlug,
        })
      );
      const response = result?.payload;
      if (response?.status === HttpStatus.HTTP_OK) {
        onSuccess?.();
      } else {
        toast(response?.message || 'Payment failed. Please try again.');
      }
    } catch (error) {
      toast('Something went wrong. Please try again.');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      {processing && <SpinnerLoader />}
      <PayPalButtons
        // Order was pre-created server-side; return the existing ID rather than
        // calling create-payment-intent again — doing so would create a duplicate order.
        createOrder={() => paypalOrderId}
        onApprove={handleApprove}
        onError={() => toast('PayPal payment failed. Please try again.')}
        onCancel={onCancel}
        style={{ layout: 'vertical', shape: 'rect' }}
        disabled={processing}
      />
    </>
  );
};

export default PayPalCheckoutForm;
